import { BasicTextField } from '../BasicTextField/BasicTextField'

import type { FormFieldWrapper } from '@ngb-frontend/shared/types'

export const HouseNumberField: React.FC<FormFieldWrapper> = ({
  name,
  ...props
}) => (
  <BasicTextField
    {...props}
    field="house-number"
    labelKey="fields.houseNumber.label"
    name={name ?? 'houseNumber'}
    inputProps={{ maxLength: 10 }}
  />
)
